export const MENTORINGSG_GROUP_ID = '1cdb16f3-8d8e-443a-8e8c-d8fae3199ded';
